import React from "react";
import { useParams } from "react-router-dom";
import { useGetWorkBySlugQuery } from "../../../redux/api/WorksApi/worksApi";
import WorksComponent from "../../../Components/WorksComponent";
import LoaderSpinner from "../../../Components/LoaderSpinner";
import SEO from "../../../Components/SEO";

const WorkDetail = () => {
  const { slug } = useParams();
  const { data: workData, isLoading } = useGetWorkBySlugQuery(slug);

  if (isLoading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <LoaderSpinner />
      </div>
    );
  if (!workData)
    return (
      <div className="text-center my-5">
        <h2>Project Not Found</h2>
      </div>
    );

  return (
    <>
      <SEO
        title={workData.meta_title || `${workData.title} - Case Study | Ideal`}
        description={workData.meta_description}
        keywords={workData.meta_keyword}
      />
      <WorksComponent data={workData} />
    </>
  );
};

export default WorkDetail;
